<div class="footer">
      <div fxFlex=100 fxLayout="row" fxLayout.xs="column" fxLayout.sm="column"  fxLayoutAlign="space-around center">
        <div>{{ 'FOOTER.MALMO.VCARD.POST_OFFICE' | translate }}</div>
        <div>{{ 'FOOTER.MALMO.VCARD.TEL' | translate }}</div>
        <div><a href="mailto:malmostad@malmo.se">{{ 'FOOTER.MALMO.VCARD.EMAIL' | translate }}</a></div>
        <div>{{ 'FOOTER.MALMO.VCARD.ORGANIZATIONS' | translate }}</div>
      </div>
</div>
